var _circle, _rect, _rect2, _rect3, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSequentialFlowIconGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#CCE4DF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.5,
    y: 15.5,
    width: 7,
    height: 7,
    rx: 1.5,
    fill: "#007A60",
    stroke: "#007A60"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.5,
    y: 31.5,
    width: 7,
    height: 7,
    rx: 1.5,
    fill: "#007A60",
    stroke: "#007A60"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31.5,
    y: 47.5,
    width: 7,
    height: 7,
    rx: 1.5,
    fill: "#007A60",
    stroke: "#007A60"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 23,
    x2: 35,
    y2: 55,
    stroke: "#007A60",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSequentialFlowIconGreen);
export default __webpack_public_path__ + "static/media/sequential-flow-icon-green.2ea54e681963e855a4b7153cd8698e68.svg";
export { ForwardRef as ReactComponent };